(() => {
  const sections = document.querySelectorAll('[data-bridge-banner]');
  if (!sections.length) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const playVideo = (video) => {
    if (!video || reduceMotion.matches) return;
    video.muted = true;
    video.setAttribute('playsinline', '');
    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {});
    }
  };

  const pauseVideo = (video) => {
    if (!video) return;
    video.pause();
  };

  sections.forEach((section) => {
    const video = section.querySelector('[data-bridge-banner-video]');
    if (!video) return;

    video.muted = true;
    video.setAttribute('playsinline', '');
    video.loop = true;

    if (!('IntersectionObserver' in window)) {
      playVideo(video);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.35) {
            playVideo(video);
          } else {
            pauseVideo(video);
          }
        });
      },
      {
        threshold: [0, 0.35, 0.6],
        rootMargin: '0px',
      }
    );

    observer.observe(section);

    if (typeof reduceMotion.addEventListener === 'function') {
      reduceMotion.addEventListener('change', () => {
        if (reduceMotion.matches) {
          pauseVideo(video);
        }
      });
    } else if (typeof reduceMotion.addListener === 'function') {
      reduceMotion.addListener(() => {
        if (reduceMotion.matches) {
          pauseVideo(video);
        }
      });
    }
  });
})();
